import { of as observableOf, Observable } from 'rxjs';

import { catchError, map } from 'rxjs/operators';
/**
 * Angular imports
 */
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpParameterCodec } from '@angular/common/http';

/**
 * KeywordSearch imports
 */
import { extractConfigFromDom } from '../../config';
import { KeywordSearchConfigModel, KeywordSearchDataModel, KeywordSearchSDSModel } from '../models';
import { KeywordSearchSearchConfigModel } from '../models/keywordsearch-search-config.model';

// using custom encoder for http params in order to have escaped + signs
class CustomEncoder implements HttpParameterCodec {
	encodeKey(key: string): string {
		return encodeURIComponent(key);
	}

	encodeValue(value: string): string {
		// same as original encoding, but not replacing %2B back to +
		return encodeURIComponent(value)
			.replace(/%40/gi, '@')
			.replace(/%3A/gi, ':')
			.replace(/%24/gi, '$')
			.replace(/%2C/gi, ',')
			.replace(/%3B/gi, ';')
			.replace(/%3D/gi, '=')
			.replace(/%3F/gi, '?')
			.replace(/%2F/gi, '/');
	}

	decodeKey(key: string): string {
		return decodeURIComponent(key);
	}

	decodeValue(value: string): string {
		return decodeURIComponent(value);
	}
}

@Injectable()
export class KeywordSearchService {
	private readonly FILTER_SEPERATOR = ':';

	config: KeywordSearchSearchConfigModel;

	constructor(private http: HttpClient) {}

	/**
	 * Loads the initial config for KeywordSearch placed by SiteCore in DOM
	 */
	public getConfig(): Observable<KeywordSearchSearchConfigModel> {
		// use config from DOM placed as JSON in html file
		const result = extractConfigFromDom();

		// cache the config
		this.config = result;

		// return the configuration to the calling component for further use
		return observableOf(result);
	}
}
